/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolOtherHousesIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-other-houses"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M3.38 18.68L3.38 11.85L3.17 12Q2.75 12.35 2.2 12.28Q1.65 12.2 1.3 11.75Q0.97 11.32 1.06 10.79Q1.15 10.25 1.57 9.9L10.38 3.2Q10.72 2.92 11.14 2.79Q11.55 2.65 11.97 2.65Q12.4 2.65 12.81 2.77Q13.22 2.9 13.57 3.17L22.43 9.85Q22.85 10.2 22.94 10.74Q23.02 11.28 22.68 11.72Q22.32 12.15 21.79 12.24Q21.25 12.32 20.82 11.97L20.57 11.8L20.57 18.68Q20.57 19.8 19.81 20.56Q19.05 21.32 17.93 21.32L6.03 21.32Q4.9 21.32 4.14 20.56Q3.38 19.8 3.38 18.68ZM8.13 15.15Q8.6 15.15 8.94 14.81Q9.28 14.47 9.28 14Q9.28 13.53 8.94 13.19Q8.6 12.85 8.13 12.85Q7.65 12.85 7.31 13.19Q6.97 13.53 6.97 14Q6.97 14.47 7.31 14.81Q7.65 15.15 8.13 15.15ZM11.97 15.15Q12.45 15.15 12.79 14.81Q13.13 14.47 13.13 14Q13.13 13.53 12.79 13.19Q12.45 12.85 11.97 12.85Q11.5 12.85 11.16 13.19Q10.82 13.53 10.82 14Q10.82 14.47 11.16 14.81Q11.5 15.15 11.97 15.15ZM15.82 15.15Q16.3 15.15 16.64 14.81Q16.98 14.47 16.98 14Q16.98 13.53 16.64 13.19Q16.3 12.85 15.82 12.85Q15.35 12.85 15.01 13.19Q14.68 13.53 14.68 14Q14.68 14.47 15.01 14.81Q15.35 15.15 15.82 15.15Z" fill={color} />
    </svg>
  );
}
